import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/dist/cjs/components/Button';
import { N600, N900 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { useAppSelector } from '../../../../redux';
import { useDevopsState } from '../../hook';
import { messages } from '../../messages';
import { fontCharlieDisplay } from '../styled';

export function SlideFinalConfirmation() {
  const { intl, devopsImageUrls } = useDevopsState();
  const goToProductUrl = useAppSelector(
    ({ sharedFormData: { goToProductUrl } }) => goToProductUrl
  );
  const { featureFlags } = useAppSelector((store) => store);
  const { enableUseCodeAWSContent } = featureFlags;
  const { createAnalyticsEvent } = useAnalyticsEvents();

  const buttonId = 'go-to-jira-42074419682455333';

  const buttonClick = () => {
    createAnalyticsEvent({
      event: 'event',
      eventName: 'goToProductButtonClicked',
      eventComponent: 'button',
      eventType: 'UI'
    }).fire();
    window.location.assign(goToProductUrl);
  };

  const codeAWSConfirmation = (
    <div>
      <CodeAwsSlideHeader>
        <SanitizedFormattedHtmlMessage {...messages.slideConfirmationHeader} />
      </CodeAwsSlideHeader>
      <CodeAwsSubText>
        <SanitizedFormattedHtmlMessage
          {...messages.slideConfirmationSubHeaderText}
        />
      </CodeAwsSubText>
      <CodeAwsImageWrapper>
        <img
          src={devopsImageUrls?.successN2E}
          alt={'image of logos with aws'}
        />
      </CodeAwsImageWrapper>

      <DevOpsCarouselEndButton>
        <Button
          appearance="primary"
          id={buttonId}
          onClick={buttonClick}
          testId="button-final-confirmation"
        >
          {intl.formatMessage(messages.slideConfirmationGetStarted, {
            product: 'Jira'
          })}
        </Button>
      </DevOpsCarouselEndButton>
      <CodeAwsFooterText>
        <SanitizedFormattedHtmlMessage
          {...messages.slideConfirmationFooterText}
        />
      </CodeAwsFooterText>
    </div>
  );
  const standardDevopsConfirmation = (
    <div>
      <SlideHeader>
        <SanitizedFormattedHtmlMessage {...messages.slideConfirmationHeader} />
      </SlideHeader>
      <SubText>
        <SanitizedFormattedHtmlMessage
          {...messages.slideConfirmationSubHeaderText}
        />
      </SubText>
      <DevopsImageWrapper>
        <img
          src={devopsImageUrls?.successN2E}
          alt={'success on a plate image'}
        />
      </DevopsImageWrapper>
      <SubText>
        <SanitizedFormattedHtmlMessage
          {...messages.slideConfirmationFooterText}
        />
      </SubText>
      <DevOpsCarouselEndButton>
        <Button
          appearance="primary"
          id={buttonId}
          onClick={buttonClick}
          testId="button-final-confirmation"
        >
          {intl.formatMessage(messages.slideConfirmationGetStarted, {
            product: 'Jira'
          })}
        </Button>
      </DevOpsCarouselEndButton>
    </div>
  );
  return enableUseCodeAWSContent
    ? codeAWSConfirmation
    : standardDevopsConfirmation;
}
const SlideHeader = styled.div`
  font-family: ${fontCharlieDisplay};
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  color: ${N600};
`;
const SubText = styled.div`
  font-family: ${fontCharlieDisplay};
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  letter-spacing: 0.3px;
  color: ${N900};
  max-width: 358px;
  margin: 16px auto;
`;
const DevOpsCarouselEndButton = styled.div`
  text-align: center;
  margin: 32px auto 12px;
`;
const DevopsImageWrapper = styled.div`
  width: 136px;
  height: 156px;
  display: flex;
  justify-content: center;
  margin: 0 auto 24px;

  svg {
    max-height: 100%;
    max-width: 100%;
  }
`;
const CodeAwsImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto 24px;

  svg {
    max-height: 100%;
    max-width: 100%;
  }
`;

const CodeAwsSlideHeader = styled.div`
  font-family: ${fontCharlieDisplay};
  font-weight: 400;
  font-size: 36px;
  line-height: 44px;
  text-align: center;
  color: ${N600};
`;
const CodeAwsSubText = styled.div`
  font-family: ${fontCharlieDisplay};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.3px;
  color: ${N900};
  margin: 16px auto;
`;

const CodeAwsFooterText = styled.div`
  font-family: ${fontCharlieDisplay};
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.3px;
  color: ${N900};
  max-width: 370px;
  margin: 16px auto;
`;
